/** Frontend mixed image+file queue UX cap. Not a backend upload-count limit. */
export const CHAT_ATTACHMENT_QUEUE_LIMIT = 10;
export const CHAT_ATTACHMENT_QUEUE_LIMIT_MESSAGE =
  "Можна додати не більше 10 вкладень за раз.";

export const ATTACHMENT_KIND_FILE = "file";

export {
  MEDIA_VIEWER_SWIPE_THRESHOLD_PX as CHAT_LIGHTBOX_SWIPE_THRESHOLD_PX,
  swipeDirection,
} from "../../shared/mediaViewer/mediaViewerSwipe";

export function isFileAttachment(item) {
  return item?.kind === ATTACHMENT_KIND_FILE;
}

export function isImageAttachment(item) {
  return Boolean(item) && !isFileAttachment(item);
}

/** Explicitly sendable phases for unified submit. All other phases fail-close. */
export function isQueuedAttachmentSendable(item, boundChatId) {
  if (!item || !item.uploadFile) return false;
  if (item.chatId != null && boundChatId != null && item.chatId !== boundChatId) {
    return false;
  }
  return item.phase === "ready" || item.phase === "upload_failed";
}

export function hasNonSendableQueuedAttachment(items, boundChatId) {
  if (!Array.isArray(items) || items.length === 0) return false;
  return items.some((item) => !isQueuedAttachmentSendable(item, boundChatId));
}

/**
 * Ordinary-file row. Must never allocate an ObjectURL.
 * Image rows continue to go through createQueueItem / usePropertyMediaQueue.
 */
export function createFileAttachmentItem(file, localId, options = {}) {
  return {
    localId,
    kind: ATTACHMENT_KIND_FILE,
    file,
    uploadFile: file,
    previewUrl: null,
    previewRevoked: false,
    heicLike: false,
    phase: "ready",
    prepareState: null,
    prepareError: null,
    uploadError: null,
    retryCount: 0,
    runId: null,
    session: null,
    edited: false,
    chatId: options.chatId != null ? options.chatId : null,
  };
}

export function remainingAttachmentCapacity(
  count,
  limit = CHAT_ATTACHMENT_QUEUE_LIMIT,
) {
  return Math.max(0, limit - count);
}

export function takeWithinCapacity(items, remaining) {
  if (!Array.isArray(items) || remaining <= 0) return [];
  if (items.length <= remaining) return items.slice();
  return items.slice(0, remaining);
}

export function formatAttachmentSize(bytes) {
  if (!Number.isFinite(bytes) || bytes < 0) return "";
  if (bytes < 1024) return `${bytes} Б`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} КБ`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} МБ`;
}

export function fileExtensionOf(name) {
  if (!name || typeof name !== "string") return "";
  const parts = name.split(".");
  if (parts.length < 2) return "";
  return parts[parts.length - 1].toLowerCase();
}
